import React, { useEffect, useState } from 'react';
import { useCart } from '../context/CartContext';

const FloatingCartButton: React.FC = () => {
  const { cart, openCart, isCartOpen } = useCart();
  const [minimized, setMinimized] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setMinimized(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (cart.length === 0 || isCartOpen) return null;

  const itemCount = cart.reduce((sum, item) => sum + item.quantity, 0);

  return (
    <button
      onClick={openCart}
      className={`fixed z-50 flex items-center justify-center shadow-lg transition-all duration-300 bg-blue-600 text-white rounded-full
        ${minimized ? 'w-12 h-12 text-base' : 'w-16 h-16 text-lg'}
        hover:bg-blue-700
        right-8 bottom-20 md:bottom-20 md:right-8
        md:w-16 md:h-16
        w-12 h-12
      `}
      style={{ boxShadow: '0 4px 16px rgba(0,0,0,0.15)' }}
      aria-label="Open cart"
    >
      <span className="relative flex items-center">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className={`w-7 h-7 md:w-7 md:h-7 w-5 h-5 ${minimized ? 'w-5 h-5' : ''}`}>
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13l-1.35 2.7A2 2 0 007.48 19h8.98a2 2 0 001.83-1.3L21 13M7 13V6a1 1 0 011-1h6a1 1 0 011 1v7" />
        </svg>
        <span className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full px-2 py-0.5 text-xs font-bold">
          {itemCount}
        </span>
      </span>
    </button>
  );
};

export default FloatingCartButton; 